import { datadogRum, DefaultPrivacyLevel } from '@datadog/browser-rum';
import config from './config';

export function initialiseRUM() {
  if (!config.datadog.enabled) {
    return;
  }

  const { applicationId, clientToken, env, service, site } = config.datadog;
  const rumConfig = {
    allowedTracingUrls: [
      /https:\/\/(?!api\.appcues\.net|auth-staging|auth\.checkit|checkit-keycloak|.*\.auth|.*\.cognito-auth).*\.(elektron-dev\.com|checkit-test\.net|checkit\.net)/
    ],
    applicationId,
    clientToken,
    defaultPrivacyLevel: DefaultPrivacyLevel.MASK_USER_INPUT,
    env,
    service,
    sessionReplaySampleRate: 100,
    sessionSampleRate: 100,
    site,
    trackLongTasks: true,
    trackResources: true,
    trackUserInteractions: true,
    version: config.version
  };

  datadogRum.init(rumConfig);
}
